/* mp-search.js - /search behaves like a page, not like the header dropdown */

(() => {
  const MIN_CHARS = 2;
  const DEBOUNCE_MS = 400;

  class MpSearchResults extends HTMLElement {
    connectedCallback() {
      if (this.bound) return;
      this.bound = true;

      this.sectionId = this.dataset.sectionId;
      this.root = this.closest('.template-search');
      this.statusEl = document.getElementById('MpSearchStatus');
      this.idleTemplate = document.getElementById('MpSearchIdle');
      this.form = document.querySelector('.template-search__search form.search');
      this.input = this.form ? this.form.querySelector('input[type="search"]') : null;

      if (!this.input || !this.sectionId) return;

      this.lastQuery = this.input.value.trim();

      const run = typeof debounce === 'function' ? debounce(() => this.request(), DEBOUNCE_MS) : null;
      this.input.addEventListener('input', () => {
        if (run) run();
        else {
          clearTimeout(this.timer);
          this.timer = setTimeout(() => this.request(), DEBOUNCE_MS);
        }
      });

      this.form.addEventListener('submit', (event) => {
        event.preventDefault();
        this.request(true);
        this.input.blur();
      });

      this.syncMeta();
    }

    syncMeta() {
      const meta = this.querySelector('[data-mp-search-meta]');
      const performed = meta ? meta.dataset.performed === 'true' : false;
      const count = meta ? parseInt(meta.dataset.count, 10) || 0 : 0;
      if (this.root) this.root.classList.toggle('template-search--empty', !performed || count === 0);
      return { performed, count };
    }

    announce(message) {
      if (this.statusEl) this.statusEl.textContent = message;
    }

    cancelScrollReveal() {
      this.querySelectorAll('.scroll-trigger').forEach((el) => el.classList.add('scroll-trigger--cancel'));
    }

    showIdle() {
      if (this.controller) this.controller.abort();
      this.classList.remove('is-loading');
      if (this.idleTemplate) this.innerHTML = this.idleTemplate.innerHTML;
      this.syncMeta();
      this.setUrl('');
      this.announce('');
    }

    setUrl(params) {
      const url = params ? `${window.location.pathname}?${params}` : window.location.pathname;
      history.replaceState({ searchParams: params }, '', url);

      if (typeof FacetFiltersForm !== 'undefined') FacetFiltersForm.searchParamsPrev = params;
    }

    buildParams(query) {
      const params = new URLSearchParams();
      params.set('q', query);
      params.set('options[prefix]', 'last');
      const sort = new URLSearchParams(window.location.search).get('sort_by');
      if (sort) params.set('sort_by', sort);
      return params.toString();
    }

    request(force = false) {
      const query = this.input.value.trim();

      if (query.length < MIN_CHARS) {
        if (this.lastQuery !== '') {
          this.lastQuery = '';
          this.showIdle();
        }
        return;
      }
      if (query === this.lastQuery && !force) return;
      this.lastQuery = query;

      const params = this.buildParams(query);

      if (this.controller) this.controller.abort();
      this.controller = new AbortController();

      this.classList.add('is-loading');
      if (!this.querySelector('#product-grid')) {
        this.innerHTML = '<p class="mp-search__searching">Searching&hellip;</p>';
      }
      this.announce('Searching');

      fetch(`${window.location.pathname}?section_id=${this.sectionId}&${params}`, {
        signal: this.controller.signal,
      })
        .then((response) => response.text())
        .then((text) => {
          const fetched = new DOMParser().parseFromString(text, 'text/html').querySelector('mp-search-results');
          if (!fetched) throw new Error('mp-search: no <mp-search-results> in the section response');

          this.innerHTML = fetched.innerHTML;
          this.cancelScrollReveal();
          this.classList.remove('is-loading');

          const { count } = this.syncMeta();
          this.setUrl(params);
          this.announce(count === 1 ? '1 result' : `${count} results`);
        })
        .catch((error) => {
          if (error.name === 'AbortError') return;

          this.classList.remove('is-loading');
          console.error(error);
          window.location.href = `${window.location.pathname}?${params}`;
        });
    }
  }

  customElements.define('mp-search-results', MpSearchResults);
})();
